import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {SequenceStatusMetric} from "../models/sequence-status-metric";
import {SequenceChannelMetric} from "../models/sequence-channel-metric";
import {SentimentMetric} from "../models/sentiment-metric";
import {FreshFeedbackMetric} from "../models/fresh-feedback-metric";


@Injectable({
    providedIn: 'root'
})
export class AdvanceAnalyticsService {

    constructor(private http: HttpClient) {
    }


    getSequenceStatusMetric(from: string, to: string, locationId: string) {
        return this.http.post<SequenceStatusMetric[]>(`${environment.BASE_URL}metric/v1/sequence/status`, {from, to, locationId});
    }

    channelWiseStatusMetric(from: string, to: string, locationId: string,status:string) {
        return this.http.post<SequenceChannelMetric>(`${environment.BASE_URL}metric/v1/sequence/channel`, {from, to, locationId, status});
    }

    questionResponseMetric(from: string, to: string, locationId: string, funnelType = 'Email Review Link') {
        return this.http.get<FreshFeedbackMetric[]>(`${environment.BASE_URL}metric/v1/question/response`, {params: {from, to, locationId, funnelType}});
    }

    getWordCloudData(from_date: string, to_date: string, locationId: string)  {
        return this.http.get<SentimentMetric>(`${environment.BASE_URL}helper/word_cloud/funnel?location_id=${locationId}&from_date=${from_date}&to_date=${to_date}`)
    }

}
